import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'
import { createMediaProjection } from '../projections/createMediaProjection'

export const createSectionPeopleProjection = (localeId: LocaleId) => {
  const MEDIA_PROJECTION = createMediaProjection(localeId)

  return groq`{
        _key,
        _type,
        ${coalesceLocaleField('title', localeId)},
        spacing,
        topBorder,
        cards[] {
          _key,
          ${coalesceLocaleField('name', localeId)},
          ${coalesceLocaleField('position', localeId)},
          ${coalesceLocaleField('content', localeId)},
          media${MEDIA_PROJECTION},
        }
      }
  `
}
